import { Component, Injector, OnInit } from '@angular/core';
import { AgreementsListDataModel } from './agreements-list.model';
import { CoreParameterModel } from '@fi-shared/models';
import { AgreementService } from '../agreement.service';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';
import { StateAccessCheckService } from '@fi-shared/fi-shared-services/state-access-check.service';
import { AppTextService } from '@fi-shared/app-text';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { TabsModuleService } from '@fi-app/utilities/tabs/tabs-module.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

@Component({
    selector: 'fi-agreements-list',
    templateUrl: './agreements-list.component.html',
    standalone: false,
})
export class FiAgreementsListComponent implements OnInit {
    ListData = new AgreementsListDataModel(this.injector);
    WildcardSearch = '';
    FiStateNames = FiStateNames;

    constructor(
        private agreementService: AgreementService,
        private loadingService: LoadingService,
        private stateAccessCheckService: StateAccessCheckService,
        private appText: AppTextService,
        private stateService: FiStateService,
        private injector: Injector,
        private tabsModuleService: TabsModuleService,
    ) {}

    ngOnInit() {
        this.ListData.Sort.Column = 'ChangedOnDate';

        this.ListData.loadDataFunc = this.LoadAgreements.bind(this);
        this.ListData.loadCountFunc = this.SetAgreementsCount.bind(this);
        this.ListData.Initialize();
    }

    GetAgreementParameter() {
        const agreementParameterModel = new CoreParameterModel();

        Object.assign(agreementParameterModel, this.ListData.getOffsetParams());

        let sortColumnName = this.ListData.Sort.Column;
        if (sortColumnName == 'ChangedOnDate') {
            sortColumnName = 'ChangedOn';
        }
        agreementParameterModel.SelectedSort = {
            ColumnName: sortColumnName,
            SortDirection: this.ListData.Sort.Reverse,
        };

        if (this.WildcardSearch) {
            agreementParameterModel.Names.push(this.WildcardSearch);
        }

        return agreementParameterModel;
    }

    SetAgreementsCount() {
        return this.agreementService.GetAgreementsCount();
    }

    LoadAgreements() {
        return this.loadingService
            .trackPromise(this.agreementService.GetAgreements(this.GetAgreementParameter()))
            .then((result) => {
                let hasAddAccess = this.stateAccessCheckService.isStateAllowedForCurrentUser(
                    FiStateNames.Agreement.Create,
                );
                result.forEach((agreement) => {
                    this.ListData.Data.push(agreement);
                    if (agreement.AgreementType == this.agreementService.TypeConfidential) {
                        hasAddAccess = false;
                    }
                });

                this.tabsModuleService.setTabsSettings({
                    listData: this.ListData,
                    disableAdd: !hasAddAccess,
                });
            });
    }
}
